export const DEFAULT_CURSOR = 'default';

export default function withCursor(mapController, map) {
	mapController.getAndObserveUncontrolled(state => state.cursor, (newCursor = DEFAULT_CURSOR) => {
		map.getViewport().style.cursor = newCursor;
	});
}
